import { useState } from "react";

interface DeliverableTab {
  id: string;
  label: string;
  icon: string;
  description: string;
  items: string[];
}

const deliverables: DeliverableTab[] = [
  {
    id: "checklist",
    label: "缺资料清单",
    icon: "ri-file-list-3-line",
    description: "按批次/票号自动生成缺资料清单,明确标注缺失字段与补充要求",
    items: [
      "按票号/批次分组展示缺失资料项",
      "标注必填/选填字段与格式要求",
      "支持批量导出与打印",
      "实时更新补充进度",
      "关联提交记录与回执状态"
    ]
  },
  {
    id: "validation",
    label: "校验报告",
    icon: "ri-shield-check-line",
    description: "提交前自动校验数据完整性与规则符合性,生成详细校验报告",
    items: [
      "三流数据口径一致性校验",
      "字段格式与规则符合性检查",
      "异常项标红提示与修正建议",
      "历史问题关联与风险提示",
      "校验通过后生成提交凭证"
    ]
  },
  {
    id: "difference",
    label: "三流差异留痕",
    icon: "ri-git-compare-line",
    description: "自动对比平台/收款/报关/发票数据,差异项标红留痕可追溯",
    items: [
      "平台订单与报关数据自动对比",
      "收款流水与申报金额差异标注",
      "发票信息与报关单据交叉校验",
      "差异原因记录与版本留痕",
      "支持按时间/批次/主体筛选查看"
    ]
  },
  {
    id: "archive",
    label: "归档包目录",
    icon: "ri-folder-zip-line",
    description: "单证目录化归档,支持按票号/批次/主体导出完整归档包",
    items: [
      "一票一目录结构化归档",
      "单证按类型自动分类存储",
      "支持按批次/主体/时间范围导出",
      "归档包含提交记录与回执凭证",
      "权限控制与操作日志留痕"
    ]
  }
];

export default function DeliverablesSection() {
  const [activeTab, setActiveTab] = useState("checklist");

  const currentDeliverable = deliverables.find(d => d.id === activeTab) || deliverables[0];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* 标题 */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            交付物与留痕示例
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            从数据归集到证据链固化,每个环节都有清晰的交付物与可追溯记录
          </p>
        </div>

        {/* Tab 导航 */}
        <div className="flex justify-center mb-12">
          <div className="inline-flex bg-white rounded-xl shadow-sm border border-gray-200 p-1.5">
            {deliverables.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`
                  flex items-center gap-2 px-6 py-3 rounded-lg text-sm font-medium
                  transition-all duration-200 whitespace-nowrap
                  ${activeTab === tab.id
                    ? "bg-teal-500 text-white shadow-md"
                    : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
                  }
                `}
              >
                <i className={`${tab.icon} text-lg`}></i>
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* Tab 内容 */}
        <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-10">
          <div className="flex items-start gap-6 mb-8">
            <div className="w-14 h-14 bg-teal-50 rounded-xl flex items-center justify-center flex-shrink-0">
              <i className={`${currentDeliverable.icon} text-3xl text-teal-600`}></i>
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                {currentDeliverable.label}
              </h3>
              <p className="text-base text-gray-600 leading-relaxed">
                {currentDeliverable.description}
              </p>
            </div>
          </div>

          {/* 交付物清单 */}
          <div className="grid gap-4">
            {currentDeliverable.items.map((item, index) => (
              <div
                key={index}
                className="flex items-start gap-4 p-4 bg-gray-50 rounded-xl hover:bg-teal-50 transition-colors duration-200"
              >
                <div className="w-6 h-6 bg-teal-500 text-white rounded-full flex items-center justify-center flex-shrink-0 text-sm font-semibold mt-0.5">
                  {index + 1}
                </div>
                <p className="text-gray-700 leading-relaxed">{item}</p>
              </div>
            ))}
          </div>

          {/* 底部提示 */}
          <div className="mt-8 pt-8 border-t border-gray-200">
            <div className="flex items-center gap-3 text-sm text-gray-500">
              <i className="ri-information-line text-lg text-teal-600"></i>
              <span>所有交付物均支持在线查看、导出下载,并保留完整操作日志与权限控制</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}